import { ICartExperience } from 'types/cart';
import isCartItemExpired from './isCartItemExpired';

/**
 * Filters out expired cart items from a cart experiences record
 * Returns only valid (non-expired) cart items
 */
const filterExpiredCartItems = (
  cartItems: Record<string, ICartExperience>,
  currentTime: Date = new Date(),
): Record<string, ICartExperience> => {
  return Object.entries(cartItems).reduce<Record<string, ICartExperience>>(
    (validItems, [itemId, item]) => {
      if (isCartItemExpired(item, currentTime)) {
        return validItems;
      }
      return {
        ...validItems,
        [itemId]: item,
      };
    },
    {},
  );
};

export default filterExpiredCartItems;
